var FileUploaderStatus;
(function (FileUploaderStatus) {
    FileUploaderStatus["ABORTED"] = "aborted";
    FileUploaderStatus["DONE"] = "done";
    FileUploaderStatus["ERROR"] = "error";
    FileUploaderStatus["INVALID"] = "invalid";
    FileUploaderStatus["LOAD"] = "load";
    FileUploaderStatus["MISSING"] = "missing";
    FileUploaderStatus["PENDING"] = "pending";
})(FileUploaderStatus || (FileUploaderStatus = {}));
export default FileUploaderStatus;
//# sourceMappingURL=file-uploader-status.js.map